import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaControl from 'Components/UI/Meta/MetaControl';

const styles = theme => ({
  root: {},
  participantInputWrapper: {
    display: 'flex',
    flexDirection: 'row',
  },
  participantInput: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
  },
  inputCol: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
  emailInputAutoComplete: {
    flexGrow: 1,
    padding: 0,
    paddingBottom: 0,
  },
  emailParticipantTypeLabel: {
    margin: theme.spacing(1, 1, 1, 0),
    fontWeight: theme.typography.fontWeightBold,
  },
});

const AdditionalBulkCommunicationRecipients = ({
  className,
  classes,
  bulkCommunicationResource,
  setAdditionalRecipients,
}) => {
  if (!bulkCommunicationResource.meta().field('additionalRecipients')) {
    return null;
  }

  return (
    <div className={classNames(classes.root, className)}>
      <div className={classes.participantInputWrapper}>
        <div className={classes.inputCol}>
          <div className={classes.participantInput} id="participant-input">
            <MetaControl
              className={classes.emailInputAutoComplete}
              resource={bulkCommunicationResource}
              attrName="additionalRecipients"
              onChange={(value) => {
                setAdditionalRecipients(value);
              }}
              value={bulkCommunicationResource.attr('additionalRecipients')}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

AdditionalBulkCommunicationRecipients.defaultProps = {
  className: '',
};

AdditionalBulkCommunicationRecipients.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  bulkCommunicationResource: PropTypes.object.isRequired,
  setAdditionalRecipients: PropTypes.func.isRequired,
};

export default withStyles(styles)(AdditionalBulkCommunicationRecipients);
